import { Table, Input, Button, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";

const TableOne = ({
  columns,
  data,
  loading,
  onSearch,
  onSelectRows,
  selectedPassengers,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    // When selectedPassengers prop changes, update the selectedRowKeys state
    if (selectedPassengers && selectedPassengers.length > 0) {
      const selectedKeys = selectedPassengers.map((passenger) => passenger.id);
      setSelectedRowKeys(selectedKeys);
    } else {
      setSelectedRowKeys([]);
    }
  }, [selectedPassengers]);
  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    onSelectRows(selectedRows); // Call the callback function with selected rows
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  // Define the pagination configuration
  const paginationConfig = {
    pageSize: 10, // Number of items per page
    current: currentPage,
    total: data.length, // Total number of items
    onChange: (page) => setCurrentPage(page), // Handle page change
  };

  return (
    <div>
      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={data}
        scroll={{ x: true }}
        rowKey="id"
        pagination={paginationConfig}
        loading={loading}
      />
    </div>
  );
};

export default TableOne;
